"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverDefaultProps = exports.popoverControllerDefaultProps = exports.POPPER_JS_REVERSE_POSITION_MAPPER = exports.POPPER_JS_POSITION_MAPPER = exports.POPOVER_BODY_RADIUS = exports.MENU_CONTENT_ROLE = exports.MAX_WIDTH_SMALL_VIEWPORT = exports.MAX_WIDTH_LARGE_VIEWPORT = exports.MAX_HEIGHT_SMALL_VIEWPORT = exports.MAX_HEIGHT_LARGE_VIEWPORT = exports.CONTENT_PADDING = exports.ARROW_WIDTH = exports.ARROW_HORIZONTAL_OFFSET = exports.ARROW_HEIGHT = exports.ANIMATION_SLIDE_AMOUNT = exports.ANIMATION_DURATION = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _interfaces = require("./interfaces");
const popoverControllerDefaultProps = exports.popoverControllerDefaultProps = {
  position: _interfaces.PopoverPosition.BottomLeading,
  shouldFocusOnOpen: false,
  shouldCloseOnFocusLeave: true,
  shouldOverflow: true
};
const defaultTriggerButtonProps = {};
const popoverDefaultProps = exports.popoverDefaultProps = {
  ...popoverControllerDefaultProps,
  triggerButtonProps: defaultTriggerButtonProps
};
const MENU_CONTENT_ROLE = exports.MENU_CONTENT_ROLE = 'menu';
const POPOVER_BODY_RADIUS = exports.POPOVER_BODY_RADIUS = (0, _utils.token)('dimensions.border.radius.200');
const ARROW_HEIGHT = exports.ARROW_HEIGHT = 8;
const ARROW_WIDTH = exports.ARROW_WIDTH = ARROW_HEIGHT * 2;
const ARROW_HORIZONTAL_OFFSET = exports.ARROW_HORIZONTAL_OFFSET = 8;
const ANIMATION_DURATION = exports.ANIMATION_DURATION = 200;
const ANIMATION_SLIDE_AMOUNT = exports.ANIMATION_SLIDE_AMOUNT = 16;
const CONTENT_PADDING = exports.CONTENT_PADDING = (0, _utils.token)('dimensions.spacing.300');
const MAX_WIDTH_LARGE_VIEWPORT = exports.MAX_WIDTH_LARGE_VIEWPORT = '40vw';
const MAX_WIDTH_SMALL_VIEWPORT = exports.MAX_WIDTH_SMALL_VIEWPORT = 'calc(100vw - 32px)';
const MAX_HEIGHT_LARGE_VIEWPORT = exports.MAX_HEIGHT_LARGE_VIEWPORT = '80vh';
const MAX_HEIGHT_SMALL_VIEWPORT = exports.MAX_HEIGHT_SMALL_VIEWPORT = '60vh';
const POPPER_JS_POSITION_MAPPER = exports.POPPER_JS_POSITION_MAPPER = {
  [_interfaces.PopoverPosition.TopLeading]: 'top-start',
  [_interfaces.PopoverPosition.TopCenter]: 'top',
  [_interfaces.PopoverPosition.TopTrailing]: 'top-end',
  [_interfaces.PopoverPosition.BottomLeading]: 'bottom-start',
  [_interfaces.PopoverPosition.BottomCenter]: 'bottom',
  [_interfaces.PopoverPosition.BottomTrailing]: 'bottom-end'
};
const POPPER_JS_REVERSE_POSITION_MAPPER = exports.POPPER_JS_REVERSE_POSITION_MAPPER = Object.entries(POPPER_JS_POSITION_MAPPER).reduce((acc, _ref) => {
  let [key, value] = _ref;
  acc[value] = key;
  return acc;
}, {});